


import { IconEdit, IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { ensureHttpPrefix } from '../../../utils/url.utils';

const UpdatePromotionDataModal = ({ baseData, callback }) => {

    const [show, setShow] = useState(false);
    const [loadingState, setLoadingState] = useState({
        loadingDestinationUrlCheck: false
    });
    const [destinationUrlCheck, setDestinationUrlCheck] = useState(null);

    const handleClose = () => { setDestinationUrlCheck(null); setShow(false) };
    const handleShow = () => setShow(true);

    const checkPromotionDestinationLink = async (e) => {
        setLoadingState({ ...loadingState, loadingDestinationUrlCheck: true });
        let postData = {
            "destinationUrl": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkPromotionDestinationLink);
            setLoadingState({ ...loadingState, loadingDestinationUrlCheck: false });
            setDestinationUrlCheck(resp);
        } else if (e.target.value?.length == 0) {
            setDestinationUrlCheck(null);
        }
    }

    const submit = async () => {
        loadingShow();
        let postData = {
            "fallbackUrl": ensureHttpPrefix(document.getElementById("destinationUrl").value?.trim()),
            "linkId": baseData?.linkId,
        }
        if (document.getElementById("name").value?.trim()) {
            postData.linkName = document.getElementById("name").value?.trim();
        }
        if (document.getElementById("description").value?.trim()) {
            postData.description = document.getElementById("description").value?.trim();
        }
        let resp = await postApi(postData, urlApi.updatePromotionDetails);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            if (callback) {
                callback();
            }
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }
    return (
        <>
            <button className='flex gap-2 text-sm items-center px-2 py-1 rounded-full bg-[#FABC0520] text-[#FABC05]' onClick={handleShow}><IconEdit size={18} /> Edit</button>
            <Modal show={show} onHide={handleClose} size='lg' backdrop="static" >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Update Destination Link</p>
                        <IconX className={`${(loadingState?.loadingDestinationUrlCheck) ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer'}`} onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <div className='mb-3'>
                        <label htmlFor="link" className='text-sm font-semibold mb-1'>Destination Link*</label>
                        <div className={`flex items-center rounded-md border-2 py-1.5 px-3 ${destinationUrlCheck && (destinationUrlCheck?.responseCode == 200 ? "border-green-700" : 'border-red-700')}`}>
                            <input type="text" className={`w-full py-1.5 text-sm focus:outline-none placeholder-[var(--secondary-text)]`} placeholder='' id='destinationUrl' defaultValue={baseData?.destinationLink} onChange={_debounce((e) => checkPromotionDestinationLink(e), 500)} />
                            {loadingState?.loadingDestinationUrlCheck && <Spinner />}
                        </div>
                        {
                            destinationUrlCheck &&
                            <div className={`text-xs text-end mt-2 ps-1 ${destinationUrlCheck?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{destinationUrlCheck?.message}</div>
                        }
                    </div>
                    <div className='mb-4'>
                        <label htmlFor="" className='text-sm font-semibold mb-1'>Title</label>
                        <input type='text' id='name' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter link title...' defaultValue={baseData?.promoTitle} />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="description" className='text-sm font-semibold mb-1'>Description</label>
                        <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='description' maxLength={255} defaultValue={baseData?.description} ></textarea>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' disabled={loadingState?.loadingDestinationUrlCheck} onClick={handleClose}>Cancel</button>
                        <button className={`${(loadingState?.loadingDestinationUrlCheck || destinationUrlCheck?.responseCode === 500) ? 'disabled-btn' : 'primary-btn'}`} disabled={loadingState?.loadingDestinationUrlCheck || destinationUrlCheck?.responseCode === 500} onClick={() => submit()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdatePromotionDataModal